/* OLINMAN Açılır 3 Kanatlı Kamp Lambası — v3.1 Shopify section (Amber/Ember açık tema PDP) */
(function(){
'use strict';
var $=function(s,c){return (c||document).querySelector(s);};
var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};
var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
var CFG=window.OKL26||{};
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}

ready(function(){
var root=$('.okl26');

/* WhatsApp inline = float ile aynı */
var wf=$('#waFloat'),wi=$('#waInline'); if(wf&&wi)wi.href=wf.href;

/* Reveal (içerik asla gizli kalmaz) */
function revealAll(){$$('.okl26 .reveal').forEach(function(e){e.classList.add('in');});}
if(root && 'IntersectionObserver' in window && !reduce){
  root.classList.add('is-ready');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
  $$('.okl26 .reveal').forEach(function(e){io.observe(e);});
  setTimeout(revealAll,3000); addEventListener('load',function(){setTimeout(revealAll,1200);});
} else { revealAll(); }

/* Galeri thumb swap */
(function(){
  var main=$('#galMain'),thumbs=$$('#galThumbs .gal-thumb');
  thumbs.forEach(function(t){t.addEventListener('click',function(){
    var src=t.getAttribute('data-img'); if(!src||!main)return;
    main.style.opacity='0'; setTimeout(function(){main.src=src;main.style.opacity='1';},160);
    thumbs.forEach(function(x){x.classList.remove('active');}); t.classList.add('active');
  });});
})();

/* ===== Paket seçimi (buy box + big CTA + modal senkron) + Shopify sepet ===== */
(function(){
  var hidden=$('#oklVariantId');
  var buyPrice=$('#buyPrice'),buyPrice2=$('#buyPrice2'),bbPrice=$('#bbPrice'),pkgTotalModal=$('#pkgTotalModal');
  function allCards(){return $$('#packs .pk').concat($$('#pkgModalWrap .pk')).concat($$('#packs2 .bc-pk'));}
  function selectVid(vid,price,total){
    if(hidden)hidden.value=vid;
    allCards().forEach(function(c){
      var on=c.getAttribute('data-vid')===String(vid);
      c.classList.toggle('sel',on);
      var r=c.querySelector('input[type=radio]'); if(r)r.checked=on;
    });
    if(buyPrice&&price)buyPrice.textContent=price;
    if(buyPrice2&&price)buyPrice2.textContent=price;
    if(bbPrice&&price)bbPrice.textContent=price;
    if(pkgTotalModal&&total)pkgTotalModal.textContent=total;
  }
  allCards().forEach(function(c){
    c.addEventListener('click',function(e){
      if(c.classList.contains('pk-out'))return;
      if(c.tagName==='LABEL')e.preventDefault();
      selectVid(c.getAttribute('data-vid'),c.getAttribute('data-price'),c.getAttribute('data-total'));
    });
  });
  /* varsayılan = EN AVANTAJLI (best_index) */
  var def=$('#packs .pk[data-qty="1"]')||$('#packs .pk');
  if(def)selectVid(def.getAttribute('data-vid'),def.getAttribute('data-price'),def.getAttribute('data-total'));

  /* modal aç/kapat */
  var modal=$('#pkgModal');
  function openM(e){if(!modal)return;if(e)e.preventDefault();modal.classList.add('open');modal.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  function closeM(){if(!modal)return;modal.classList.remove('open');modal.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  $$('[data-pkg-open]').forEach(function(o){o.addEventListener('click',openM);});
  if(modal){$$('[data-pkg-close]',modal).forEach(function(c){c.addEventListener('click',closeM);});addEventListener('keydown',function(e){if(e.key==='Escape')closeM();});}

  /* modaldan sepete ekle + checkout */
  var go=$('#pkgGo');
  if(go){go.addEventListener('click',function(){
    var vid=hidden?hidden.value:null;
    if(!vid){var s=$('#pkgModalWrap .pk.sel');if(s)vid=s.getAttribute('data-vid');}
    if(!vid){var sg=$('#pkgSingleId');if(sg)vid=sg.value;}
    if(!vid)return;
    var addUrl=CFG.cartAddUrl||'/cart/add';
    go.disabled=true;
    fetch(addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})})
    .then(function(r){if(!r.ok)throw new Error('cart');return r.json();})
    .then(function(){window.location.href='/checkout';})
    .catch(function(){
      var f=document.createElement('form');f.method='post';f.action=addUrl;
      var a=document.createElement('input');a.type='hidden';a.name='id';a.value=vid;
      var b=document.createElement('input');b.type='hidden';b.name='quantity';b.value='1';
      f.appendChild(a);f.appendChild(b);document.body.appendChild(f);f.submit();
    });
    setTimeout(function(){go.disabled=false;},6000);
  });}
})();

/* Vitrin şeridi */
(function(){
  var strip=$('#strip'); if(!strip)return;
  var prev=$('#stripPrev'),next=$('#stripNext');
  function step(){var c=strip.querySelector('.strip-card');return (c?c.getBoundingClientRect().width+16:300);}
  if(prev)prev.addEventListener('click',function(){strip.scrollBy({left:-step(),behavior:'smooth'});});
  if(next)next.addEventListener('click',function(){strip.scrollBy({left:step(),behavior:'smooth'});});
  var down=false,sx=0,sl=0;
  strip.addEventListener('pointerdown',function(e){down=true;sx=e.clientX;sl=strip.scrollLeft;strip.classList.add('drag');});
  addEventListener('pointerup',function(){down=false;strip.classList.remove('drag');});
  strip.addEventListener('pointerleave',function(){down=false;strip.classList.remove('drag');});
  strip.addEventListener('pointermove',function(e){if(!down)return;strip.scrollLeft=sl-(e.clientX-sx);});
})();

/* Countdown */
(function(){
  var H=$('#cdH'),M=$('#cdM'),S=$('#cdS'); if(!H)return;
  var WIN=24*3600*1000,KEY='okl26_cd',dl;
  try{dl=parseInt(localStorage.getItem(KEY),10);if(isNaN(dl)||dl<Date.now()){dl=Date.now()+WIN;localStorage.setItem(KEY,String(dl));}}catch(e){dl=Date.now()+WIN;}
  function p(x){return(x<10?'0':'')+x;}
  function tick(){var d=dl-Date.now();if(d<=0){dl=Date.now()+WIN;try{localStorage.setItem(KEY,String(dl));}catch(e){}d=WIN;}var t=Math.floor(d/1000);H.textContent=p(Math.floor(t/3600));M.textContent=p(Math.floor(t%3600/60));S.textContent=p(t%60);}
  tick();setInterval(tick,1000);
})();

/* Stock */
(function(){
  var txt=$('#stockTxt'); if(!txt)return;
  var left=CFG.stockLeft||7; txt.textContent=left+' adet';
})();

/* Sosyal kanıt */
(function(){
  var box=$('#proof'),nm=$('#proofName'),msg=$('#proofMsg'),x=$('#proofX'); if(!box)return;
  var names=['Ahmet Y.','Zeynep K.','Mert A.','Elif S.','Burak T.','Derya N.','Caner Ö.','Gül B.','Onur D.','Pınar E.','Serkan M.','Yasemin A.'];
  var cities=['İstanbul','Ankara','İzmir','Bursa','Antalya','Adana','Konya','Trabzon','Eskişehir','Samsun','Muğla','Kayseri'];
  var acts=[function(n,c){return n.split(' ')[0]+' ('+c+') <b>sipariş verdi</b> · az önce';},function(n,c){return n.split(' ')[0]+' ('+c+') 2\'li paketi <b>satın aldı</b>';},function(n,c){return n.split(' ')[0]+' ('+c+') siparişini <b>tamamladı</b>';},function(n,c){return n.split(' ')[0]+' ('+c+') şu anda <b>inceliyor</b>';}];
  var hideT,showT;function rand(a){return a[Math.floor(Math.random()*a.length)];}
  function show(){nm.textContent='Yeni hareket';msg.innerHTML=rand(acts)(rand(names),rand(cities));box.classList.add('show');hideT=setTimeout(hide,5000);}
  function hide(){box.classList.remove('show');showT=setTimeout(show,7000+Math.random()*5000);}
  if(x)x.addEventListener('click',function(){clearTimeout(hideT);hide();});
  showT=setTimeout(show,4500);
})();

/* FAQ */
(function(){
  var items=$$('.faq-item');
  items.forEach(function(it){var q=$('.faq-q',it),a=$('.faq-a',it);if(!q||!a)return;
    q.addEventListener('click',function(){var open=it.classList.contains('open');
      items.forEach(function(o){o.classList.remove('open');var aa=$('.faq-a',o);if(aa)aa.style.maxHeight=null;});
      if(!open){it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
    });
  });
})();

/* Lightbox */
(function(){
  var lb=$('#lightbox'),img=$('#lbImg'),x=$('#lbX'); if(!lb)return;
  $$('.okl26 [data-lb]').forEach(function(el){el.addEventListener('click',function(){img.src=el.getAttribute('data-lb');lb.classList.add('open');});});
  function close(){lb.classList.remove('open');}
  if(x)x.addEventListener('click',close);
  lb.addEventListener('click',function(e){if(e.target===lb)close();});
  addEventListener('keydown',function(e){if(e.key==='Escape')close();});
})();

}); /* ready */
})();
